
















































































































import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";
import {
  FieldFlagsBag,
  Validator
} from "vee-validate";
import { BootstrapVueRowDetails, FiservDebitCardInfo } from "@/shared/types";
import { useNotifierStore } from "@/shared/store/notifier";
import { useFiservDebitCardsStore } from "@/shared/store/fiservDebitCards";

@Component({
  components: {}
})
export default class FiservDebitCardSetPinForm extends Vue {

  $validator: Validator;
  fields: FieldFlagsBag;


  notifierStore = useNotifierStore();
  fiserveDebitCardsStore = useFiservDebitCardsStore();


  @Prop()
  row: BootstrapVueRowDetails;

  @Prop()
  card: FiservDebitCardInfo;

  @Prop()
  thisIsAChangePinForm: boolean;

  oldPin = "";
  pin = "";
  confirmPin = "";

  userHasTouchedOldPinInput = false;
  userHasTouchedPinInput = false;
  userHasTouchedConfirmPinInput = false;
  formIsBeingSubmitted = false;

  onSubmitChanges (e: Event) {
    e.preventDefault();

    this.pinInputBlurred();
    this.pinConfirmInputBlurred();

    this.$validator.validateAll()
        .then(isValid => {
          if (this.formIsBeingSubmitted || !isValid) {
            return;
          }
          this.formIsBeingSubmitted = true;

          if (this.thisIsAChangePinForm) {
            this.changePin();
          } else {
            this.setPin();
          }

        });
  }

  setPin () {
    this.fiserveDebitCardsStore.setFiservDebitCardPIN({
          fiservUserInfoId: this.card.fiservUserInfoId,
          pin: this.pin
        })
        .then(() => {
          this.notifierStore.setSuccess(
              `PIN for card with last four digits "${this.card.cardNumberLast4}" set successfully.`);
          this.row.toggleDetails();
        })
        .catch(() => {
          this.formIsBeingSubmitted = false;
        });
  }

  changePin () {
    this.fiserveDebitCardsStore.setFiservDebitCardPIN({
          fiservUserInfoId: this.card.fiservUserInfoId,
          oldPin: this.oldPin,
          pin: this.pin
        })
        .then(() => {
          this.notifierStore.setSuccess(
              `PIN for card with last four digits "${this.card.cardNumberLast4}" changed successfully.`);
          this.row.toggleDetails();
        })
        .catch(() => {
          this.formIsBeingSubmitted = false;
        });
  }

  oldPinInputBlurred () {
    this.$validator.validateAll();
    this.userHasTouchedOldPinInput = true;
  }

  validateOldPinState (ref) {
    if (this.userHasTouchedOldPinInput) {
      return !this.errors.has(ref);
    }
    return null;
  }

  pinInputBlurred () {
    this.$validator.validateAll();
    this.userHasTouchedPinInput = true;
  }

  validatePinState (ref) {
    if (this.userHasTouchedPinInput) {
      return !this.errors.has(ref);
    }
    return null;
  }

  pinConfirmInputBlurred () {
    this.$validator.validateAll();
    this.userHasTouchedConfirmPinInput = true;
  }

  validateConfirmPinState (ref) {
    if (this.userHasTouchedConfirmPinInput) {
      return !this.errors.has(ref);
    }
    return null;
  }

  togglePasswordMask (inputId: string) {
    const passwordField = document.getElementById(inputId);

    if (passwordField.getAttribute("type") === "password") {
      passwordField.setAttribute("type", "text");
    } else {
      passwordField.setAttribute("type", "password");
    }
  }

  get confirmPasswordValidation () {
    return {
      required: true,
      confirmed: !!this.confirmPin && this.pin
    };
  }

}
